import React, { FC, ReactElement } from 'react';
import DemoZoneListItem from './DemoZoneList/DemoZoneListItem';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsLoggedIn, getIsRegistrationRequired, getDemozoneThemeList, getContentDataIntro } from '../../../stores/reducers/userData';
import routes from '../../../config/routes';
import './demozone.sass';
import localeFieldResolver from '../../../helpers/locale-field-finder';
import { internalizationState } from '../../../stores/reducers/sections';

export interface MainZoneDataProps {
  description: string;
  description_en?: string;
  id: string;
  image: string;
  relatedPage: string;
  title: string;
  title_en?: string;
  type: string;
}

const DemoZoneMain:FC = (): ReactElement => {
  const history = useHistory();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isRegistrationRequired = useSelector(getIsRegistrationRequired);
  const { backendURL } = useSelector(getContentDataIntro);
  const exhibitionMainPageData = useSelector(getDemozoneThemeList);
  const shouldRegister = !isLoggedIn && isRegistrationRequired;
  const demozoneTitleBg = exhibitionMainPageData.image ? {backgroundImage: `url(${backendURL}/${exhibitionMainPageData.image})`} : {backgroundColor: exhibitionMainPageData.color};
  const { activeLangState } = useSelector(internalizationState);

  if (shouldRegister) history.push(routes.REGISTER);

  return (
    <>
      {
        (exhibitionMainPageData.title || exhibitionMainPageData.title_en) &&
        <div className="demozone-main__header" style={demozoneTitleBg}>
          <div className="container">
            <h1>{ localeFieldResolver(exhibitionMainPageData, 'title', activeLangState) }</h1>
          </div>
        </div>

      }
      <div className="inner-section">
        <div className="container demozone-main__zones" style={{marginTop:'100px'}}>
          {
            exhibitionMainPageData.blocks.map((zoneItem: MainZoneDataProps): any => {
              return (
                <DemoZoneListItem zoneItem={zoneItem} key={zoneItem.id} />
              )
            })
          }
        </div>
      </div>
    </>
  )
}

export default DemoZoneMain
